module.exports = __webpack_public_path__ + "assets/juncal.ad10660f.svg";